module.exports = __webpack_public_path__ + "img/USERS.40b0d700.svg";